const loaderMiddleware = store => {
  const { dispatch } = store;

  return next => action => {
    ['_REQUEST', '_SUCCESS', '_REJECTED'].forEach((item, key) => {
      if (action.type.endsWith(item)) {
        dispatch({
          type: `@@loader/${!key ? 'ACTIVE' : 'INACTIVE'}`,
          payload: action.type.replace(item, ''),
        });
      }
    });

    next(action);
  };
};
export default loaderMiddleware;
